function hasPermission(user, roles) {
    return (Array.isArray(roles) &&
        Array.isArray(user.clients) &&
        user.clients.some(client => roles.indexOf(client.role) >= 0));
}
export default hasPermission;
//# sourceMappingURL=hasPermission.js.map